import {
    Model
} from '@vuex-orm/core'
import User from '@/models/User'
import Media from "@/models/Media"
import Comment from "@/models/Comment"
export default class Note extends Model {
    static entity = 'notes'

    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(null),
            content: this.attr(''),
            owner_id: this.attr(''),
            board_id: this.attr(''),
            order: this.attr(''),
            owner: this.belongsTo(User, 'owner_id'),
            editing: this.attr(false),
            medias: this.hasMany(Media, 'note_id'),
            comments: this.hasMany(Comment, 'note_id')
        }
    }


    static createNote(note) {
        return this.api().post(`/boards/${note.board_id}/notes`, note, {
            save: false
        })
    }
    static updateNote(note) {
        return this.api().post(`/boards/${note.board_id}/notes/${note.id}`, note, {
            save: false

        })
    }


    static listNotes(board_id, page = 1, limit = 999, relationships = ['owner']) {
        return this.api().get(`/boards/${board_id}/notes`, {
            params: {
                page: page,
                limit: limit,
                ...(relationships ? {
                    with: relationships
                } : {}),
            },
            dataTransformer: (response) => {
                let storageArray = []
                response.data.data.forEach(element => {
                    let target = element
                    Object.assign(target, target.attributes)
                    // if (relationships.includes('owner')) {
                    //     Object.assign(target.owner, target.owner.attributes)
                    //     element.owner.id = parseInt(element.owner.id)
                    // }

                    storageArray.push(target)
                });
                Note.insert({
                    data: storageArray
                })

            }
        })
    }


    static showNote(board_id, note_id, relationships = 'owner') {
        return this.api().get(`/boards/${board_id}/notes/${note_id}`, {
            dataTransformer: (response) => {
                let target = response.data.data
                Object.assign(target, target.attributes)
                return target
            },
            params: {
                ...(relationships ? {
                    with: relationships
                } : {})

            }
        })
    }
    static deleteNote(board_id, note_id) {
        return this.api().delete(`/boards/${board_id}/notes/${note_id}`, {
            save: false
        })
    }
    static attachFile(board_id, note_id, file, type = 'image') {
        return this.api().post(`/boards/${board_id}/notes/${note_id}/attachments/save-attachment`, file, {
            save: false,

        })
    }
    static attachComment(board_id, note_id, comment) {
        return this.api().post(`/boards/${board_id}/notes/${note_id}/comments`, {
            body: comment
        }, {
            save: false,

        })
    }
    static deleteComment(board_id, note_id, comment_id) {
        return this.api().delete(`/boards/${board_id}/notes/${note_id}/comments/${comment_id}`, {
            save: false,

        })
    }
    static deleteFile(board_id, note_id, media_id) {
        return this.api().delete(`/boards/${board_id}/notes/${note_id}/attachments/${media_id}`, {
            save: false,

        })
    }
}